import React from 'react';
import { Tag } from 'antd';

export const DeliveryUtils = {
  renderPOFTags: (deliveryId: number, pofData: Record<number, any>, deletePOFById: (proofId: number, deliveryId: number) => void) => {
    const pofData_item = pofData[deliveryId];
    if (!pofData_item || !pofData_item.proofs) return null;

    const proofs = pofData_item.proofs.filter((proof: any) => !proof.is_deleted && proof.fulfillment_type !== 'LR');
    if (proofs.length === 0) return null;

    return proofs.map((pof: any, index: number) => {
      const isLR = pof.fulfillment_type === 'LR';
      return (
        <Tag
          key={`${pof.id}-${index}`}
          color={isLR ? "orange" : "green"}
          closable
          onClose={(e) => {
            e.preventDefault();
            deletePOFById(pof.id, deliveryId);
          }}
          onClick={() => pof.proof_file && window.open(pof.proof_file, "_blank")}
          style={{ cursor: "pointer", marginBottom: "4px" }}
        >
          {isLR ? `Lorry Receipt ${index + 1}` : `Delivery Proof ${index + 1}`}
        </Tag>
      );
    });
  },

  renderLRTags: (deliveryId: number, pofData: Record<number, any>, deletePOFById: (proofId: number, deliveryId: number) => void) => {
    const pofData_item = pofData[deliveryId];
    if (!pofData_item || !pofData_item.proofs) return null;

    const lrProofs = pofData_item.proofs.filter((proof: any) => !proof.is_deleted && proof.fulfillment_type === 'LR');
    if (lrProofs.length === 0) return null;

    return lrProofs.map((pof: any, index: number) => (
      <Tag
        key={`lr-${pof.id}-${index}`}
        color="orange"
        closable
        onClose={(e) => {
          e.preventDefault();
          deletePOFById(pof.id, deliveryId);
        }}
        onClick={() => pof.proof_file && window.open(pof.proof_file, "_blank")}
        style={{ cursor: "pointer", marginBottom: "4px" }}
      >
        Lorry Receipt {index + 1}
      </Tag>
    ));
  }
};
